export const INTERNAL_KREDIT_QUERY_KEY = 'internal_kredit';

export const INTERNAL_KREDIT_CANONICAL_QUERY = `?${INTERNAL_KREDIT_QUERY_KEY}`;

export const INTERNAL_KREDIT_SEARCH_ROUTE =
  '/alqi-satqi?has_internal_loan=true';

export const isCanonicalInternalKreditHomeSearchParams = searchParams => {
  if (searchParams.size !== 1 || !searchParams.has(INTERNAL_KREDIT_QUERY_KEY)) {
    return false;
  }

  return searchParams.get(INTERNAL_KREDIT_QUERY_KEY) === '';
};

export const isCanonicalInternalKreditHomeAsPath = asPath => {
  const queryIndex = asPath.indexOf('?');

  if (queryIndex === -1) {
    return false;
  }

  const pathname = asPath.slice(0, queryIndex) || '/';

  if (pathname !== '/') {
    return false;
  }

  return isCanonicalInternalKreditHomeSearchParams(
    new URLSearchParams(asPath.slice(queryIndex + 1))
  );
};

export const isInternalKreditSearchAsPath = asPath => {
  if (isCanonicalInternalKreditHomeAsPath(asPath)) {
    return true;
  }

  if (
    asPath === INTERNAL_KREDIT_SEARCH_ROUTE ||
    /\?has_internal_loan=true/.test(asPath)
  ) {
    return true;
  }

  const [pathname = '', search = ''] = asPath.split('?');

  return (
    /\/alqi-satqi/.test(pathname) &&
    new URLSearchParams(search).get('has_internal_loan') === 'true'
  );
};

export const shouldUseInternalKreditCanonical = asPath => {
  if (isCanonicalInternalKreditHomeAsPath(asPath)) {
    return true;
  }

  const [pathname = '', search = ''] = asPath.split('?');

  if (!search || !/\/alqi-satqi/.test(pathname)) {
    return false;
  }

  return new URLSearchParams(search).get('has_internal_loan') === 'true';
};

export const INTERNAL_KREDIT_CANONICAL_PATH = `/${INTERNAL_KREDIT_CANONICAL_QUERY}`;

export const getInternalKreditSearchRewritePath = locale => {
  const [pathname, search = ''] = INTERNAL_KREDIT_SEARCH_ROUTE.split('?');

  return {
    pathname: `/${locale}${pathname}`,
    search: search ? `?${search}` : ''
  };
};
